if (!customElements.get('product-form')) {
	customElements.define('product-form', class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.minicart = document.querySelector('mini-cart');
			this.eventContext = this.form.dataset.eventContext;
		}

		onSubmitHandler(event) {
			event.preventDefault();
			const submitButton = this.querySelector('[type="submit"]');
			if (submitButton.classList.contains('loading')) {
				return;
			}

			this.handleErrorMessage();

			submitButton.setAttribute('aria-disabled', true);
			submitButton.classList.add('loading');
			this.querySelector('.button-overlay-spinner').classList.remove('hidden');

			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			const formData = new FormData(this.form);
			formData.append('sections', this.minicart.getSectionsToRender().map((section) => section.id));
			formData.append('sections_url', window.location.pathname);
			config.body = formData;

			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then(async (response) => {
    if (response.status) {
        this.handleErrorMessage(response.description);
        return;
    }

  this.minicart.renderContents(response);

/*
 * ============================================================
 * MANDATORY DIRT BIKE FREIGHT
 * ============================================================
 */

const addedItem =
    response.items && response.items[0]
        ? response.items[0]
        : response;

if (
    addedItem &&
    addedItem.properties &&
    addedItem.properties['_freight_charge']
) {

    const freightQuantity = addedItem.quantity;
    const freightVariantId = 44339729104955;

    try {

        const freightConfig = fetchConfig('javascript');
        freightConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete freightConfig.headers['Content-Type'];

        const freightFormData = new FormData();

        freightFormData.append(
            'items[0][id]',
            freightVariantId
        );

        freightFormData.append(
            'items[0][quantity]',
            freightQuantity
        );

        freightFormData.append(
            'items[0][properties][_freight_for]',
            'mandatory'
        );

        freightFormData.append(
            'sections',
            this.minicart
                .getSectionsToRender()
                .map((section) => section.id)
        );

        freightFormData.append(
            'sections_url',
            window.location.pathname
        );

        freightConfig.body = freightFormData;

        const freightResponse = await fetch(
            routes.cart_add_url,
            freightConfig
        );

        const freightResult = await freightResponse.json();

        if (freightResult.status) {
            console.error(
                'Freight charge error:',
                freightResult.description
            );
        } else {

            /*
             * Update the mini-cart with the freight included.
             */
            this.minicart.renderContents(freightResult);
        }

    } catch (error) {

        console.error(
            'Mandatory freight error:',
            error
        );

    }
}


if (window.themeSettings.redirectToCart) {
						location.href = '/cart';
					} else {
						this.minicart.open(submitButton);
					}

					const event = new CustomEvent('cart:item-add', {
						detail: {
							items: [response],
							context: this.eventContext,
						},
					});
					document.dispatchEvent(event);
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					submitButton.classList.remove('loading');
					submitButton.removeAttribute('aria-disabled');
					this.querySelector('.button-overlay-spinner').classList.add('hidden');
				});
		}

		handleErrorMessage(errorMessage = false) {
			this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
			this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

			this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

			if (errorMessage) {
				this.errorMessage.textContent = errorMessage;
			}
		}
	});
}
